import Vue from 'vue'

export default {
  register (data) {
    return Vue.axios.post('/auth/register', data)
  },

  resetPassword (username) {
    return Vue.axios.post('/auth/reset', { 'email': username})
  },

  changePassword (data) {
    return Vue.axios.post('/auth/changepassword', data)
  },

  updateProfile (data) {
    return Vue.axios.put('/auth/user', data)
  }
}
